import type { AuthResponseDto, RegisterDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { trackSignUp } from "@/client/libs/analytics";
import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { migrateResumeDraftToAccount } from "@/client/services/auth/migrate-resume-draft";
import { useAuthStore } from "@/client/stores/auth";

export const register = async (data: RegisterDto) => {
  const response = await axios.post<AuthResponseDto, AxiosResponse<AuthResponseDto>, RegisterDto>(
    "/auth/register",
    data,
  );

  return response.data;
};

export const useRegister = () => {
  const setUser = useAuthStore((state) => state.setUser);

  const {
    error,
    isPending: loading,
    mutateAsync: registerFn,
  } = useMutation({
    mutationFn: register,
    onSuccess: async (data) => {
      setUser(data.user);
      queryClient.setQueryData(["user"], data.user);
      trackSignUp("email");
      await migrateResumeDraftToAccount();
    },
  });

  return { register: registerFn, loading, error };
};
